import { TableClassKey } from '@mui/material';
import { OverridesStyleRules } from '@mui/material/styles/overrides';
import { getColor } from '../../colors/colors';

export const CustomTable: Partial<OverridesStyleRules<TableClassKey>> | undefined = {
  root: {
    marginBottom: '56px',

    '& .MuiTableCell-root': {
      color: getColor('text'),
      padding: '6px 10px',
      borderBottom: `1px solid #0000001A`,
    },

    '& .MuiTableHead-root': {
      '& .MuiTableRow-root': {
        '& .MuiTableCell-root': {
          fontWeight: 600,
          paddingLeft: '16px',
        },
      },
    },
    '& .MuiTableBody-root': {
      '& .MuiTableRow-root': {
        '& .MuiTableCell-root': {
          paddingLeft: '16px',
        },

        '&.no-matches': {
          '& .MuiTableCell-root': {
            // borderBottom: 'none',
          },
        },
      },
    },
    '& .MuiTableFooter-root': {
      '& .MuiTableRow-root': {
        '& .MuiTableCell-root': {
          borderBottom: 'none',
        },
      },
    },
  },
};
